import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import {
	RETURN_TO_DRAFT_PAYMENT_MODAL__BODY_TEXT_TITLE,
	RETURN_TO_DRAFT_PAYMENT_MODAL__CANCEL,
	RETURN_TO_DRAFT_PAYMENT_MODAL__SUBMIT,
	RETURN_TO_DRAFT_PAYMENT_MODAL__TITLE,
} from '../data/constants';

interface ReturnToDraftPaymentModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const ReturnToDraftPaymentModal = (props: ReturnToDraftPaymentModalProps) => {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{RETURN_TO_DRAFT_PAYMENT_MODAL__TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{RETURN_TO_DRAFT_PAYMENT_MODAL__BODY_TEXT_TITLE}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color='neutralButton'>
					{RETURN_TO_DRAFT_PAYMENT_MODAL__CANCEL}
				</Button>
				<Button onClick={onConfirm} variant='contained' color='primary'>
					{RETURN_TO_DRAFT_PAYMENT_MODAL__SUBMIT}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ReturnToDraftPaymentModal;
